import Api from './baseApi';

export default {


    hbStatusGroup: (Order) => {
        let url = "/api/orders/hbStatusGroup?v=1";
        if (Order.startDate)
            url += `&startDate=${Order.startDate}`;
        if (Order.endDate)
            url += `&endDate=${Order.endDate}`;
        return Api.get(url)
    },
    searchOrder: (Order) => {
        let url = "/api/orders/fast?v=1";
        if (Order.search)
            url += `&q=${Order.search}`;
        if (Order.state > -1)
            url += `&state=${Order.state}`;
        if (Order.startDate)
            url += `&startDate=${Order.startDate}`;
        if (Order.endDate)
            url += `&endDate=${Order.endDate}`;
        if (Order.insuranceId > -1)
            url += `&insuranceId=${Order.insuranceId}`;
        if (Order.hbState !== "")
            url += `&status=${Order.hbState}`;
        if (Order.city !== "-1")
            url += `&city=${Order.city}`;
        if (Order.isComission)
            url += `&isComission=${Order.isComission}`;

        
        return Api.get(url)
    },
    getOrders: () => Api.get('/api/Orders'),
    getCity: () => Api.get('/api/Orders/City'),
    getOrder: (id) => Api.get(`/api/Orders/${id}`),
    putOrder: (Order) => Api.put(`/api/Orders/${Order.id}`, Order),
    deleteOrder: (Order) => Api.delete(`/api/Orders/${Order.id}`, Order),
    postOrder: (Order) => Api.post(`/api/Orders`, Order),
    bulkUpdateStates: (Model) => {

        let url = `/api/orders/bulkUpdateStates`;
        if (Model.insuranceId > -1)
            url += `?insuranceId=${Model.insuranceId}`
        return Api.patch(url, Model);
    },
    saveInsurance: (Model) => {
        let url = `/api/orders/SendInsurance?insuranceId=${Model.insuranceId}`;
        return Api.patch(url, Model);
    },
    uploadInsurance: (Model) => {
        let url = `/api/Insurances/Upload`;
        return Api.post(url, Model, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    },


    reSendInvoice: (Model) => Api.patch(`/api/orders/reSendInvoice`, Model),
    
    sendReferenceNumberToIdefix: (packageNumber, refNumber) => {
        console.log('Sending reference number to Idefix:', { packageNumber, refNumber });
        let url = `/api/Idefix/SendReferenceNumberToIdefix?packageNumber=${packageNumber}&refNumber=${refNumber}`;
        return Api.post(url);
    }

}